/**
 * joinLiveCall — entrer dans l'appel, le même geste sur mobile et sur le web.
 *
 * Revenu dans la séance : la sortie restée en file ne doit plus le faire sortir de l'appel, et celle
 * déjà en vol arrive avant le `joinCall`, jamais après (`withdrawLiveExitOnRejoin`). La réponse
 * garde l'heure de la demande ; un échec se dit à la télémétrie et rend `null`.
 */
import { liveServiceV2 } from "../../../data/services/liveServiceV2"
import { apiCall } from "../../shared/apiCall"
import { type StudentLiveConnectionOptions } from "./liveConnectionTypes"
import { withdrawLiveExitOnRejoin } from "./liveExitQueue"

export type JoinedLiveCall = { data: unknown; requestedAt: number }

export function joinLiveCall(
    dispatch: unknown,
    liveSessionId: number,
    telemetry: StudentLiveConnectionOptions["telemetry"]
): Promise<JoinedLiveCall | null> {
    return withdrawLiveExitOnRejoin(liveSessionId)
        .then(() => {
            const requestedAt = Date.now()
            return apiCall(dispatch as never, liveServiceV2.joinCallV2, { routeParams: { id: liveSessionId } }).then(
                (data: unknown) => ({ data, requestedAt })
            )
        })
        .catch((cause: unknown) => {
            telemetry.error("join_call", cause)
            return null
        })
}
